import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import React from "react";
import TableWithLabels from "../../../../ui/tables/table-with-labels/TableWithLabels";
import {Radio} from "@material-ui/core";
import {useSelector} from "react-redux";
import EmptyRow from "../../../../ui/tables/rows/empty-row/EmptyRow";

const CustomersTable = (props) => {
    const companies = useSelector(state => state.authReducer.companies.data);
    const page = useSelector(state => state.authReducer.companies.page);
    const rowsPerPage = useSelector(state => state.authReducer.companies.rowsPerPage);
    const count = useSelector(state => state.authReducer.companies.count);
    const loading = useSelector(state => state.authReducer.companies.loading);

    const headCells = [
        {id: 'checkmark', label: '', minWidth: 0, align: 'left'},
        {id: 'codiceCliente', label: 'Codice Cliente', minWidth: 150, align: 'left'},
        {
            id: 'regioneSociale',
            label: 'Ragione sociale',
            minWidth: 200,
            align: 'left',
        },
        {
            id: 'pIva',
            label: 'P.IVA',
            minWidth: 100,
            align: 'left'
        },
        {
            id: 'codiceFiscale',
            label: 'C.F.',
            minWidth: 100,
            align: 'left'
        },
        // {
        //     id: 'clientePadre',
        //     label: 'Cliente Padre',
        //     minWidth: 200,
        //     align: 'left'
        // }
    ];

    const clickTableRowCustomers = (row) => {
        props.setSelectedCustomer(row.integrationId);
        props.setIsApplicaDisabled(false);
    }

    const tableRows = (

        count !== 0 ? companies.map((row, index) => {
            return (
                <TableRow
                    hover
                    onClick={() => clickTableRowCustomers(row)}
                    key={"customer-table-" + index}>
                    <TableCell align="left" style={{padding: "0 0 0 0.75em"}}><Radio
                        checked={props.selectedCustomer === row.integrationId}
                        onChange={(e) => props.setSelectedCustomer(e.target.value)}
                        value={row.integrationId}
                        name="selectedCustomer"
                    /></TableCell>
                    <TableCell align="left">{row.integrationId}</TableCell>
                    <TableCell align="left">{row.name}</TableCell>
                    <TableCell align="left">{row.piva}</TableCell>
                    <TableCell align="left">{row.codiceFiscale}</TableCell>
                    {/*<TableCell align="left">{row.parentCustomerName ? row.parentCustomerName : ""}</TableCell>*/}

                </TableRow>
            );
        }) : <EmptyRow text="dato" colSpan={headCells.length}/>
    );

    return (
        <TableWithLabels headCells={headCells}
                         tableRows={tableRows}
                         tableData={companies}
                         page={page}
                         fetchData={props.fetchData}
                         rowsPerPage={rowsPerPage}
                         count={count}
                         loading={loading}/>
    )
}


export default CustomersTable;
